import { env } from "../../config/env";

/** S3-ключ или уже готовый URL → публичный URL бакета. */
export function getPublicMediaUrl(s3KeyOrUrl: string): string {
  const raw = s3KeyOrUrl.trim();
  if (!raw) return "";

  if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) {
    return raw;
  }

  const base = env.mediaCdnUrl.replace(/\/$/, "");
  const key = raw.replace(/^\//, "");
  return `${base}/${key}`;
}
